import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { prettyLocalDate } from '../../../lib/time';
import {formatCurrency} from '../../../lib/currency';

const useStyles = makeStyles({
  summary: {
    border: 'solid 1px #b5b5b5',
    borderRadius: 4,
    margin: '1rem 0 1rem 0',
  }
});

const BillingSummary = ({billing}) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.summary}>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell></TableCell>
            <TableCell align="right">Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              {billing.plan_name}
              {' @ '}
              {formatCurrency(billing.plan_amount.excl)}
            </TableCell>
            <TableCell>
              {billing.plan_discount>0 && ('' + billing.plan_discount + '% discount')}</TableCell>
            <TableCell align="right">{formatCurrency(billing.plan_discounted_amount.excl)}</TableCell>
          </TableRow>
          {billing.extra_listings > 0 &&
            <TableRow>
              <TableCell>
                {billing.listing_name}
                {' '}
                {billing.extra_listings}
                {' @ '}
                {formatCurrency(billing.listing_amount.excl)}
              </TableCell>
              <TableCell>
                {billing.listing_discount>0 && billing.listing_discount + '% discount'}</TableCell>
              <TableCell align="right">{formatCurrency(billing.extra_listings * billing.listing_discounted_amount.excl)}</TableCell>
            </TableRow>
          }
          <TableRow>
            <TableCell>GST</TableCell>
            <TableCell></TableCell>
            <TableCell align="right">
              {formatCurrency(billing.total_discounted_amount.gst)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total (including GST)</TableCell>
            <TableCell></TableCell>
            <TableCell align="right">
              {formatCurrency(billing.total_discounted_amount.incl)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Next Payment Date: {billing.overdue ? 'Today' : prettyLocalDate(billing.next_payment_date)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

BillingSummary.propTypes = {
  billing: PropTypes.object.isRequired,
};

export default BillingSummary;
